import React, { useEffect } from "react";
import { Layout, Row, Col, Button } from "antd";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
//component
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import TriggerInit from "./trigger/trigger_init";
//action
import { setHighlight } from "store/bailiff/nav/nav.action";
//selector
import "./style.css";
import BailiffDetail from "./component/bailiff_list";
import { useResponsive } from "hook/useResponsive";
import { defaultClientDetailSelector } from "store/user/(default)/client/default_client.selector";

const { Content } = Layout;

const DraftBailiffScreen = () => {
  // -------------------------- VAR --------------------------
  const { mobile } = useResponsive();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const detail = useSelector(defaultClientDetailSelector);
  const email = detail?.email?.split("@")[0] || "Chưa có tên";
  const title = mobile ? "Khách hàng" : `Khách hàng: ${email}`;
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {/* Client   */}
          <BailiffDetail />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={title} />
      <Content className="content">
        <Row justify={"center"} gutter={[0, 30]}>
          <Col xl={14} lg={14} md={22} xs={24}>
            {renderBody()}
          </Col>
        </Row>
        {/* Dialog */}
        {/* Trigger */}
        <TriggerInit />
      </Content>
    </Layout>
  );
};

export default DraftBailiffScreen;
